import { Controller } from "@hotwired/stimulus"

// Submits the wrapping period form whenever a radio selection changes.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
